import React from 'react';
import { Link } from 'react-router-dom';


function ProjectItem(props) {
    return (
        <>
            <article class="postcard dark blue">
                <a class="postcard__img_link" href="#">
                    <img class="postcard__img" src={props.img_src} alt="Image Title" />
                </a>
                <div class="postcard__text">
                    <h1 class="postcard__title blue"><a href="#">{props.title}</a></h1>
                    <div class="postcard__subtitle small">
                        <time>
                            <i class="fa-solid fa-code"></i> {props.tags}
                        </time>
                    </div>
                    <div class="postcard__bar"></div>
                    <div class="postcard__preview-txt">{props.description}</div>
                    <ul class="postcard__tagbox">
                        <li class="tag__item play blue">
                            <a href={props.github_link} target="_blank"><i class="fa-brands fa-github"></i>  Open GitHub</a>
                        </li>
                    </ul>
                </div>
            </article>
        </>
    )
}

export default ProjectItem